/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Mar 12 2024
 **/

import { atom, useAtomValue } from "jotai";

import { useGroup } from "@/frameworks/core/API";
import { initSpaceStateFn } from "./private/utils";

export const CreateSpaceState = atom<CreateSpaceStateType>(initSpaceStateFn({ accessAllowType: "PUBLIC" }));

export default function useCreateSpaceState() {
	const state = useAtomValue(CreateSpaceState);
	const groupAPI = useGroup();

	return {
		state,
		defaultSpaceState: initSpaceStateFn({ accessAllowType: state.accessAllowType }),
		groupData: groupAPI.inquiry.result.data
	};
}
